import React from "react";
import GreyTable from "../../../../components/Tables/GreyTable";
import { Col, Row, Container } from "react-bootstrap";
import { useSelector } from "react-redux";

import Cookies from "js-cookie";
import { useTheme } from "../../../../Themecontext/Themecontext";

const columns = [
  {
    label: "Sr No",
    key: "srNo",
    align: "center",
  },
  {
    label: "Production Group",
    key: "productionGroup",
    align: "left",
  },
  {
    label: "Quality",
    key: "quality",
    align: "left",
  },
  {
    label: "Party Name",
    key: "partyName",
    align: "left",
  },
  {
    label: "Opening Meters",
    key: "openingMeters",
    align: "right",
    format: true,
  },
  {
    label: "Rate",
    key: "rate",
    align: "right",
    format: true,
  },
  {
    label: "Amount",
    key: "amount",
    align: "right",
    format: true,
  },
  {
    label: "Charts",
    key: "charts",
    align: "center",
  },
];

const data = [
  {
    srNo: 1,
    productionGroup: "Cotton",
    quality: "Cotton 40s",
    partyName: "Ramesh Textiles Pvt Ltd",
    openingMeters: 1250,
    rate: 82.5,
    amount: 103125,
    charts: true,
  },
  {
    srNo: 2,
    productionGroup: "Cotton",
    quality: "Cotton 60s",
    partyName: "Sharma Fabrics Co",
    openingMeters: 980,
    rate: 88,
    amount: 86240,
    charts: true,
  },
  {
    srNo: 3,
    productionGroup: "Polyester",
    quality: "Polyester Soft",
    partyName: "Gujarat Mills Corporation",
    openingMeters: 1540,
    rate: 74.25,
    amount: 114345,
    charts: true,
  },
  {
    srNo: 4,
    productionGroup: "Polyester",
    quality: "Polyester Heavy",
    partyName: "South India Textiles",
    openingMeters: 1120,
    rate: 79.5,
    amount: 89040,
    charts: true,
  },
  {
    srNo: 5,
    productionGroup: "Silk",
    quality: "Silk Premium",
    partyName: "Maharashtra Weaving Mills",
    openingMeters: 450,
    rate: 210,
    amount: 94500,
    charts: true,
  },
  {
    srNo: 6,
    productionGroup: "Silk",
    quality: "Silk Light",
    partyName: "Delhi Dyeing House",
    openingMeters: 390,
    rate: 185,
    amount: 72150,
    charts: true,
  },
  {
    srNo: 7,
    productionGroup: "Nylon",
    quality: "Nylon Stretch",
    partyName: "Ramesh Textiles Pvt Ltd",
    openingMeters: 1325,
    rate: 68.75,
    amount: 91093.75,
    charts: true,
  },
  {
    srNo: 8,
    productionGroup: "Nylon",
    quality: "Nylon Premium",
    partyName: "Sharma Fabrics Co",
    openingMeters: 1180,
    rate: 72,
    amount: 84960,
    charts: true,
  },
  {
    srNo: 9,
    productionGroup: "Denim",
    quality: "Denim Blue",
    partyName: "Gujarat Mills Corporation",
    openingMeters: 1675,
    rate: 95,
    amount: 159125,
    charts: true,
  },
  {
    srNo: 10,
    productionGroup: "Denim",
    quality: "Denim Black",
    partyName: "South India Textiles",
    openingMeters: 1430,
    rate: 98.5,
    amount: 140855,
    charts: true,
  },
  {
    srNo: 11,
    productionGroup: "Cotton",
    quality: "Cotton Compact",
    partyName: "Maharashtra Weaving Mills",
    openingMeters: 860,
    rate: 91,
    amount: 78260,
    charts: true,
  },
  {
    srNo: 12,
    productionGroup: "Polyester",
    quality: "Polyester Matte",
    partyName: "Delhi Dyeing House",
    openingMeters: 1210,
    rate: 76.25,
    amount: 92262.5,
    charts: true,
  },
];

export default function TotalMeter() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;

  return (
    <Container fluid style={{ padding: 0, margin: 0 }}>
      <Row
        className="justify-content-center"
        style={{ margin: 0, padding: 0 }}
      >
        <Col md={12} style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "20px 24px",
                margin: 0,
              }}
            >
              <h2
                className="text-xl font-semibold tracking-wide"
                style={{
                  fontSize: "18Px",
                  margin: 0,
                  letterSpacing: "1px"
                }}
              >
                MONTHWISE DELIVERY DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"
              >
                Financial Year: (FY 2025-26) • Total: 5,75,19,753.38 meters
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns} data={data} />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}